import { ApiClient } from 'services/ApiClient';

export const createApplicant = (token: string) => {
  return ApiClient.post(`/sumsub/create-applicant`, null, {
    headers: {
      accept: 'application/json',
      authorization: `Bearer ${token}`
    }
  });
};

export const getSumsubAccessToken = (token: string) => {
  return ApiClient.post(`/sumsub/access-token`, null, {
    headers: {
      accept: 'application/json',
      authorization: `Bearer ${token}`
    }
  });
};

export const applicantStatus = (token: string) => {
  return ApiClient.get(`/sumsub/applicant-status`, {
    headers: {
      accept: 'application/json',
      authorization: `Bearer ${token}`
    }
  });
};
